// extracted by mini-css-extract-plugin
export default {"owner-type-selector":"owner-type-selector-3141"};